<template>
  <g>
    <path
      :transform="transform"
      :d="d"
      :stroke="offColor"
      stroke-width="3"
      fill="transparent"
    />
    <axis
      :scaleFunction="x"
      :scale="scale"
      :height="height"
      :color="offColor"
      :offset="offset"
      :data="points"
      :unit="unit"
    />
    <hexa-point
      v-for="(point, index) in points"
      :scale="scale"
      :key="index"
      :x="point.x"
      :y="point.y"
      :text="point.text"
      :color="color"
    />
  </g>
</template>

<script>
import { scaleLinear } from 'd3-scale'
import { extent } from 'd3-array'
import { line } from 'd3-shape'
import Axis from '../libraries/Axis'
import HexaPoint from '../combo/HexaPoint'
export default {
  name: 'HexaLine',
  components: {
    HexaPoint,
    Axis
  },
  props: {
    data: {
      type: Array,
      default () { return [] }
    },
    color: {
      type: String,
      default: '#f56043'
    },
    offColor: {
      type: String,
      default: '#757575'
    },
    width: {
      type: Number,
      default: 608
    },
    height: {
      type: Number,
      default: 275
    },
    offset: {
      type: Object,
      default () { return { top: 24, left: 48, bottom: 48, right: 48 }}
    },
    scale: {
      type: Number,
      default: 1
    },
    animation: {
      type: Boolean,
      default: true
    },
    animationDuration: {
      type: Number,
      default: 3000
    },
    animationOptions: {
      type: Object,
      default () {
        return {
          delay: 0,
          easing: 'Bounce',
          easingEdge: 'Out'
        }
      }
    },
    unit: {
      type: String,
      default: '%'
    }
  },
  methods: {
    xDomain () {
      return extent(this.data.map(d => d.year), (d, index) => d || index)
    },
    xRange () {
      return [0, this.width]
    },
    yDomain () {
      // return [14, 15.6]
      // return [28, 32]
      return [Math.round(Math.min(...this.data.map(d => d.value)) * .9), Math.max(...this.data.map(d => d.value))]
      // return extent(this.data.map(d => d.value), (d, index) => d || index)
    },
    yRange () {
      return [this.height, 0]
    }
  },
  computed: {
    x () {
      return scaleLinear().domain(this.xDomain()).rangeRound(this.xRange())
    },
    y () {
      return scaleLinear().domain(this.yDomain()).rangeRound(this.yRange()).nice()
    },
    d () {
      return line().defined(d => d)
        .x(d => this.x(d.year))
        .y(d => this.y(d.value))(this.data)
    },
    points () {
      return this.data.map(d => {
        return {x: this.x(d.year) + this.offset.left, y:this.y(d.value) + this.offset.top, text: d.value.toString().replace(/\.(\d?\d?)\d*/, (a,b) => `,${b}`)}
      })
    },
    transform () {
      return `translate(${this.offset.left}, ${this.offset.top})`
    }
  }
}
</script>

<style>

</style>
